import { httpInstancePaymentLink } from '@/services/httpInstance';

const getMerchantService = async (merchantId: string) => {
  const endpoint = `/api/v1/merchants/${merchantId}`;

  try {
    const response = await httpInstancePaymentLink.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error('❌ Error al obtener el merchant:', {
      merchantId,
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return error?.response;
  }
};

export default getMerchantService;
